var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content__table" },
    [
      _c("p", { staticClass: "page-content__table__title" }, [
        _vm._v("Por transportadora")
      ]),
      _vm._v(" "),
      _c(
        "sc-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.billings,
            bordered: false,
            hoverable: false,
            striped: false,
            scrollable: false
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var row = ref.row
                return [
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Transportadora", centered: false } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to:
                              "/recon/billing/logistic-providers/" +
                              row.logisticProviderId
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getLogisticProviderName(
                                  row.logisticProviderId
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Faturas", centered: false } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(row.billingsCount) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Valor das faturas", centered: false } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatPTCurrency(row.billingsTotalValue)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { label: "Quantidade de pedidos", centered: false }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(row.shipmentOrdersCount) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Faturas com divergência",
                        centered: false
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(row.divergentBillingsCount) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { label: "Valor da divergência", centered: false }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPTCurrency(
                              row.divergentBillingsTotalValue
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      row.divergentBillingsTotalValue > 0
                        ? _c(
                            "sc-tag",
                            {
                              attrs: {
                                size: "is-medium",
                                type: "is-danger is-light",
                                rounded: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.calculateDivergentPercentage(row)
                                  ) +
                                  " %\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { attrs: { slot: "empty" }, slot: "empty" },
            [
              _c("sc-table-empty", {
                attrs: {
                  icon: "far fa-box-open",
                  message: _vm.emptyTableTemplate
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1f23fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1f23fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/components/billings-by-provider-table/BillingsByLPTable.vue
// module id = null
// module chunks = 